import { render } from "./NatalChartReportsDashboard.vue?vue&type=template&id=0220611a&scoped=true"
import script from "./NatalChartReportsDashboard.vue?vue&type=script&lang=js"
export * from "./NatalChartReportsDashboard.vue?vue&type=script&lang=js"

import "./NatalChartReportsDashboard.vue?vue&type=style&index=0&id=0220611a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0220611a"]])

export default __exports__